import { useCallback, useRef } from 'react'
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect'

/**
 * Provides a referentially stable getter function that can be used in event
 * handlers to obtain the latest `value` without triggering a re-render.
 */
export const useGetter = <S>(value: S): (() => S) => {
    const ref = useRef(value)
    useIsomorphicLayoutEffect(() => {
        ref.current = value
    })
    return useCallback(() => ref.current, [ref])
}
